export default __webpack_public_path__ + "static/simple-scatter-6adb5ad5df35d838d4d59d7a32263232.png";